import React from 'react';
import { Link } from 'react-router-dom';

import './Services.css';

const packages = [
    {
        name: 'Launch Site',
        bestFor: 'A focused website for a service business, operator, or personal brand that needs a credible web presence.',
        includes: ['Scope and sitemap', 'Up to 5 core pages', 'Responsive implementation', 'Contact form', 'Search and analytics setup']
    },
    {
        name: 'Product Website',
        bestFor: 'A larger marketing site with clearer positioning, richer content, and room to grow.',
        includes: ['UX review', 'Page and content structure', 'CMS or blog setup', 'Performance pass', 'Launch support']
    },
    {
        name: 'Product Build',
        bestFor: 'A focused software engagement for apps, dashboards, account flows, payments, integrations, or internal tools.',
        includes: ['Product discovery', 'User flows', 'Frontend and API work', 'Auth or payments', 'Launch documentation']
    }
];

const processSteps = [
    'Clarify the goal, users, constraints, and what needs to be true for the project to succeed.',
    'Turn the scope into screens, flows, technical assumptions, and a delivery plan.',
    'Build the core experience with responsive states, accessibility, and maintainability in mind.',
    'Test, deploy, document the important pieces, and make the handoff easy to own.'
];

function Services() {
    return (
        <div className="container services-page">
            <section className="services-hero">
                <p className="eyebrow">Services & project packages</p>
                <h1 className="display-4 text-bold text-indigo">Websites, product builds, and practical engineering support.</h1>
                <p className="lead">
                    I work with founders, operators, and small teams that need a reliable build partner for websites, web apps, integrations, and technical cleanup.
                </p>
                <div className="services-actions">
                    <Link to="/contact" className="btn btn-indigo">Request a Quote</Link>
                    <Link to="/portfolio" className="btn btn-link">View Work</Link>
                </div>
            </section>

            <section aria-labelledby="packages-heading">
                <h2 id="packages-heading" className="display-6 text-indigo">Project Packages</h2>
                <div className="package-grid">
                    {packages.map((projectPackage) => (
                        <article className="package-card" key={projectPackage.name}>
                            <h3>{projectPackage.name}</h3>
                            <p>{projectPackage.bestFor}</p>
                            <ul>
                                {projectPackage.includes.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>
            </section>

            <section className="quote-section" aria-labelledby="quote-heading">
                <h2 id="quote-heading" className="display-6 text-indigo">Scope, Pricing, and Delivery</h2>
                <p>
                    I keep estimates explicit: what is included, what can wait, where the technical risk is, and what the first useful milestone should deliver.
                </p>
                <div className="quote-grid">
                    <div>
                        <h3>Typical deliverables</h3>
                        <p>Sitemap, wireframes, responsive UI, implementation, integrations, analytics, QA, deployment, and handoff notes.</p>
                    </div>
                    <div>
                        <h3>Common extensions</h3>
                        <p>CMS setup, booking flows, Stripe payments, dashboards, authentication, accessibility review, performance work, and ongoing maintenance.</p>
                    </div>
                </div>
            </section>

            <section aria-labelledby="process-heading">
                <h2 id="process-heading" className="display-6 text-indigo">Process</h2>
                <ol className="process-list">
                    {processSteps.map((step, index) => (
                        <li key={step}>
                            <span>{String(index + 1).padStart(2, '0')}</span>
                            {step}
                        </li>
                    ))}
                </ol>
            </section>
        </div>
    );
}

export default Services;
